import { useTranslation } from "react-i18next";
import { rawItems } from "../filters/useFilterPurpose";
import singleMode from "./selectBaseSingle";
import multiMode from "./selectBaseMulti";
import { useSelector } from "react-redux";
export default ({ multiple, initial }) => {
	const { t } = useTranslation(["filtersAndSelectors"]);

	// ** A/B TESTS: New Purpose
	const userId = useSelector((state) => state.global.user.id);
	const newPurpose = userId % 2 === 1;

	const filteredRawItems = newPurpose
		? rawItems.filter(
				(item) =>
					item.key !== "sponsored_arrangement" && item.key !== "fun"
		  )
		: rawItems.filter((item) => item.key !== "one_time");

	const items = filteredRawItems.map((item) => ({
		...item,
		content: t(`filtersAndSelectors:purpose.${item.key}`),
	}));

	const sortedItems = items;

	const compute = multiple
		? {
				valueToApiParam: (value) => value.map((item) => Number(item)),
				apiParamToValue: (values) => {
					return values.map(
						(value) =>
							items.find((item) => item.meta.for === value).value
					);
				},
		  }
		: {
				valueToApiParam: (value) => {
					const current = items.find((item) => item.value === value);
					return current ? Number(current.value) : null;
				},
				apiParamToValue: (value) =>
					items.find((item) => item.meta.for === value).value,
		  };
	let computedInitial = null;
	if (Array.isArray(initial)) {
		computedInitial = initial
			? initial.map((purpose) => {
					return {
						value: items.find(
							(item) => String(item.meta.for) === String(purpose)
						)?.value,
					};
			  })
			: [];
	} else if (typeof initial === "number") {
		computedInitial = initial;
	}
	return {
		rawItems,
		items: sortedItems,
		compute,
		isMultiple: multiple,
		...(multiple
			? multiMode({ items: sortedItems, initial: computedInitial })
			: singleMode({ items: sortedItems, initial: computedInitial })),
	};
};
